"use client";

import { motion } from "framer-motion";
import { Download } from "lucide-react";
import React from "react";
import { AuroraBackground } from "./aurora-background.js";

const Hero = () => {
    return (
        <AuroraBackground>
            <motion.div
                initial={{ opacity: 0.0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{
                    delay: 0.3,
                    duration: 0.8,
                    ease: "easeInOut",
                }}
                className="relative flex flex-col gap-4 items-center justify-center px-4"
            >
                <div className="text-3xl md:text-7xl font-bold dark:text-white text-center">
                    Bookseed: Short Book Summaries
                </div>
                <div className="font-extralight text-base md:text-4xl dark:text-neutral-200 py-4 text-center">
                    Grow Your Knowledge, One Summary at a Time.
                </div>
                <div className="mt-6 flex justify-center">
                    <motion.a
                        href="https://github.com/bhavyavishnani/Bookseed-Release/releases/download/release-1/Bookseed.apk" // Change to your actual APK link
                        download
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="relative inline-flex items-center justify-center px-6 py-3 font-semibold text-black bg-white border-2 border-black rounded-full shadow-md transition-all"
                    >
                        <Download className="w-5 h-5 mr-2" />
                        Download App
                    </motion.a>
                </div>
            </motion.div>
        </AuroraBackground>
    );
};

export default Hero;
